import React from 'react';
import styled from 'styled-components';

import W from '../styled/Wrapper';
import H from '../styled/Heading';
import RichText from './RichText';


const Wrapper = styled(W)`
  padding-bottom: 63px;

  @media only screen and (max-width: 810px) {
    padding-bottom: 14px;
  }
`;

const TextWrapper = styled.div`
  width: 75%;
  padding: 20px 0 0;

  @media only screen and (max-width: 1750px) {
    width: 100%;
  }
  
  @media only screen and (max-width: 810px) {
    width: 100%;
    padding: 0;
  }
`;

const Heading = styled(H)`
  margin-bottom: 20px;

  @media only screen and (max-width: 810px) {
    font-size: 36px;
    line-height: 43px;
    margin-bottom: 10px;
  }
`;

const Paragraph = styled.div`
  @media only screen and (max-width: 810px) {
    margin-bottom: 14px;
  }
`;

const Text = ({ data, locs }) => {

  return (
    <Wrapper>
      <TextWrapper left={data.imageOnTheRight}>
        {data.heading && <Heading size={3}>{data.heading}</Heading>}
        {data.text && (
          <Paragraph>
            <RichText
              content={data.text.raw}
              firstParMargin
            />
          </Paragraph>
        )}
      </TextWrapper>
    </Wrapper>
  );
};

export default Text;
